import React from "react"
import { MdClose } from "react-icons/md"

import {
	MobergButton,
	MobergButtonShape,
	MobergButtonVariant,
} from "../../../../../Components/MobergButton/MobergButton"
import { MobergTheme } from "../../../../../Components/MobergThemes/MobergColors"
import { MobergIconSize } from "../../../../../Components/MobergIcon/MobergIcon"
import { MobergRow, MobergColumn } from "../../../../../Moberg"
import { useModalProvider } from "../../../../../Providers/ModalProvider"

import {
	ModalContainer,
	ModalHeader,
	ModalTitle,
	ModalContent,
} from "./modal-primitives"
import { CalibrationStatusBanner, CalibrationStatusDetails } from "./CalibrationStatusBanner"
import { CalibrationRuler } from "./CalibrationRuler"

interface StatusModalProps {
	pxPerMm: number
	details: CalibrationStatusDetails
	setMode: (mode: "status" | "calibration") => void
}

export const StatusModal: React.FC<StatusModalProps> = ({ pxPerMm, details, setMode }) => {
	const { close } = useModalProvider()

	return (
		<ModalContainer role="dialog" aria-modal="true" $variant="status">
			<ModalHeader>
				<ModalTitle>EEG Display Calibration</ModalTitle>
				<MobergButton
					theme={MobergTheme.BLACK}
					variant={MobergButtonVariant.CLEAR}
					shape={MobergButtonShape.SQUARE}
					onClick={close}
				>
					<MdClose size={MobergIconSize.REGULAR} />
				</MobergButton>
			</ModalHeader>

			<ModalContent $isCalibration={false}>
				<CalibrationStatusBanner details={details} />
				<MobergColumn gap={24} style={{ width: "100%" }}>
					<CalibrationRuler pxPerMm={pxPerMm} />
				</MobergColumn>
			</ModalContent>

			<MobergRow
				verticalAlign="center"
				horizontalAlign="flex-end"
				style={{ padding: "20px 24px 24px", borderTop: "1px solid var(--color-border-light)", gap: 16 }}
			>
				<MobergRow horizontalAlign="flex-end" style={{ gap: 12 }}>
					<MobergButton
						theme={MobergTheme.BLUE}
						variant={MobergButtonVariant.FILLED}
						onClick={() => setMode("calibration")}
						style={{ padding: "12px 28px" }}
					>
						Recalibrate Display
					</MobergButton>
				</MobergRow>
			</MobergRow>
		</ModalContainer>
	)
}
